import request from '@/utils/request'

const system = {
  name: 'system',
  state: {
    isSystemDetailLoading: false,
    systemDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_SYSTEM_DETAIL_LOADING: (state, data) => {
      state.isSystemDetailLoading = data
    },
    SET_MODULES_SYSTEM_DETAIL_DATA: (state, data) => {
      state.systemDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    querySystemDetailData({ commit }, id) {
      commit('SET_IS_MODULES_SYSTEM_DETAIL_LOADING', true)
      commit('SET_MODULES_SYSTEM_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/system/systemDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_SYSTEM_DETAIL_LOADING', false)
          commit('SET_MODULES_SYSTEM_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_SYSTEM_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetSystemDetailData({ commit }) {
      commit('SET_MODULES_SYSTEM_DETAIL_DATA', {})
    }
  }
}

export default system
